/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const QuestionStore = require('../../stores/QuestionStore.jsx');
const AnswerActions = require('../../actions/AnswerActions.jsx');
const AnswerStore = require('../../stores/AnswerStore.jsx');

const StaticImagePreviewSection = React.createClass({
  propTypes: {
    productData: React.PropTypes.object,
    answers: React.PropTypes.object
  },

  getInitialState() {
    return {
      activeImage: 0,
      activeExtraImage: null,
      scrollIndex: null
    };
  },

  imgRenderViews: [],
  extraProductImages: [],

  generateImageUrl(imagePath) {
    if (typeof imagePath == 'string' && imagePath.startsWith('sku=') && Config.images.cantoUrl != null) {
      return Config.images.cantoUrl.replace('sku={sku}', imagePath).replace('{smi}', Loader.schoolCode);
    } else {
      return Config.images.s3url + imagePath;
    }
  },

  componentWillMount() {
    // grab 1st-level image objects which correspond to views that have image metadata values top/bottom/side/etc.
    let staticImages = _.get(this.props.productData, 'metadata.StaticImage');
    for (let view in staticImages) this.imgRenderViews.push(view);

    // now grab extra product images by product metadata number (ExtraProductImage.X where X = 1, 2, 3, ...)
    let extraProductImages = _.get(this.props.productData, 'metadata.ExtraProductImage');
    _.each(extraProductImages, (image) => {
      this.extraProductImages.push(image);
    });

    // Let's prefetch all of the StaticImages and ExtraProductImages (if any). But delay it 2 seconds to ensure other images have priority
    setTimeout(() => {
      let head = document.getElementsByTagName('head')[0];

      _.each(staticImages, (view) => {
        _.each(view, (metal) => {
          _.each(metal, (finish) => {
            let prefetchImage = document.createElement('link');
            prefetchImage.setAttribute('rel', 'prefetch');
            prefetchImage.setAttribute('href', this.generateImageUrl(finish));

            head.appendChild(prefetchImage);
          });
        });
      });

      if (extraProductImages) {
        _.each(extraProductImages, (image) => {
          let prefetchImage = document.createElement('link');
          prefetchImage.setAttribute('rel', 'prefetch');
          prefetchImage.setAttribute('href', this.generateImageUrl(image));

          head.appendChild(prefetchImage);
        });
      }
    }, 2000);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      let activeQuestion = _.findWhere(nextProps.answers, { lastAnswered: true });
      let activeView = _.get(activeQuestion, 'question.metadata.ImageRenderView');

      // if the question that was just answered has a view associated with it, switch to that view
      if (activeView) {
        let activeViewIndex = this.imgRenderViews.indexOf(activeView);

        if (activeViewIndex !== -1) {
          this.setState({
            activeImage: activeViewIndex
          });
        }
      }
    }
  },

  handleSlide(index, extraIndex) {
    AnswerActions.clearLastAnswered();

    this.setState({
      activeImage: index,
      activeExtraImage: extraIndex
    });
  },

  scrollToElement(right) {
    const node = ReactDOM.findDOMNode(this);
    var carousel = node.querySelector('.uc-carousel');
    var image = node.querySelector('.uc-image-nav-img');

    carousel.scrollTo({
      left: carousel.scrollLeft + (right ? image.offsetWidth : -image.offsetWidth),
      behavior: 'smooth'
    });
  },

  scrollToNext(index, count) {
    if (index == count) {
      return;
    }

    index++;
    this.scrollToElement(true);
    this.setState({
      scrollIndex: index
    });
  },

  scrollToPrev(index, minCount) {
  if (index == minCount) {
    return;
  }

  index--;

  this.scrollToElement(false);
    this.setState({
      scrollIndex: index
    });
  },

  buildImageUrl(view, extraUrl) {
    if (view == null && extraUrl) {
      let imagePath = extraUrl;
      let extraIndex = this.extraProductImages.indexOf(extraUrl);
      let imageUrl = this.generateImageUrl(imagePath);
      AnswerActions.setProductImage(imageUrl, extraIndex, extraUrl);
      return imageUrl;
    }
    let productData = this.props.productData;
    let imageMetadata = _.get(productData, 'metadata.StaticImage');
    let answers = this.props.answers;

    // get default image attributes
    let defaultMetalColor = _.get(productData, 'metadata.DefaultMetalColor') || 'yellow';
    let defaultMetalFinish = _.get(productData, 'metadata.DefaultMetalFinish') || 'antique';

    // get relevant questions/answers
    let metalQuestionId = _.get(QuestionStore.getQuestionByName('Metal'), 'id');
    let metalFinishQuestionId = _.get(QuestionStore.getQuestionByName('MetalFinish'), 'id');
    let metalAnswer = _.get(answers, metalQuestionId + '.part.metadata.ImageAttribute');
    let metalFinishAnswer = _.get(answers, metalFinishQuestionId + '.part.metadata.ImageAttribute');

    // set image attributes accordingly
    let metalColor = metalAnswer || defaultMetalColor;
    // we may have a valid answer for metal finish but not have any corresponding product image metadata for it; if so, try default finish
    let metalFinish = (_.get(imageMetadata, view + '.' + metalColor + '.' + metalFinishAnswer)) ? metalFinishAnswer : defaultMetalFinish;

    let imagePath = _.get(imageMetadata, view + '.' + metalColor + '.' + metalFinish) || 'uc_image_loading.gif';
    let imageUrl = this.generateImageUrl(imagePath);
    let viewIndex = this.imgRenderViews.indexOf(view);

    if (imagePath !== 'uc_image_loading.gif' && AnswerStore.images[viewIndex] !== imageUrl) {
      AnswerActions.setProductImage(imageUrl, viewIndex, view);
    }

    return imageUrl;
  },

  getImageAlt(viewIndex, extraIndex = null) {
    let name = _.get(this.props.productData, `metadata.lang.${ln}.DisplayName`) || _.get(this.props.productData, 'name');
    let alt = extraIndex ? name + " extra image: " + this.extraProductImages[extraIndex]: 
      name + " " + this.imgRenderViews[viewIndex] + " view";
    return alt;
  },

  render() {
    let views = this.imgRenderViews;
    let alt = this.getImageAlt(this.state.activeImage, this.state.activeExtraIndex);

    let imagesCarouselMinCount = window.innerWidth > Config.breakpoints.small && window.innerWidth < 1180 ? 3 : 4;
    let imagesCount = views.length + this.extraProductImages.length;
    let carousel = imagesCount > imagesCarouselMinCount;

    return (
      <div className='uc-image-preview-section'>
        <div className='uc-preview-image' ref='imagePreview'>
          <img alt={alt} src={this.buildImageUrl(views[this.state.activeImage], this.extraProductImages[this.state.activeExtraImage])} />
        </div>

        {!carousel ? <div className="uc-image-nav" style={{ display: views.length <= 1 && this.extraProductImages.length < 1 ? 'none' : null }}>
          {_.map(views, (view, index) => {
            let activeClass = this.state.activeImage === index ? ' uc-active' : '';

            return (
              <div className={'uc-image-nav-img' + activeClass}
                key={index}
                onClick={this.handleSlide.bind(null, index, null)}>
                <img alt={this.getImageAlt(index)} src={this.buildImageUrl(view, null)} />
              </div>
            );
          })}
          {_.map(this.extraProductImages, (extraUrl, index) => {
            let activeClass = this.state.activeExtraImage === index ? ' uc-active' : '';

            return (
              <div className={'uc-image-nav-img' + activeClass}
                 key={index}
                 onClick={this.handleSlide.bind(null, null, index)}>
                 <img alt={this.getImageAlt(null, index)} src={this.buildImageUrl(null, extraUrl)} />
              </div>
            );
          })}
        </div> : 
        <div className="uc-image-nav uc-carousel" style={{ display: views.length <= 1 && this.extraProductImages.length < 1 ? 'none' : null }}>
        <button style={{ opacity: this.state.scrollIndex == imagesCarouselMinCount || this.state.scrollIndex == null ? 0.5 : 1}}
                onClick={this.scrollToPrev.bind(null, this.state.scrollIndex || imagesCarouselMinCount, imagesCarouselMinCount)}
                className='uc-carousel-button-left'></button>
        {_.map(views, (view, index) => {
          let activeClass = this.state.activeImage === index ? ' uc-active' : '';

          return (
            <div className={'uc-image-nav-img' + activeClass}
              key={index}
              onClick={this.handleSlide.bind(null, index, null)}>
              <img alt={this.getImageAlt(index)} src={this.buildImageUrl(view, null)} />
            </div>
          );
        })}
        {_.map(this.extraProductImages, (extraUrl, index) => {
          let activeClass = this.state.activeExtraImage === index ? ' uc-active' : '';

          return (
            <div className={'uc-image-nav-img' + activeClass}
               key={index}
               onClick={this.handleSlide.bind(null, null, index)}>
               <img alt={this.getImageAlt(null, index)} src={this.buildImageUrl(null, extraUrl)} />
            </div>
          );
        })}
        <button style={{ opacity: this.state.scrollIndex == imagesCount ? 0.5 : 1}} className='uc-carousel-button-right'
                onClick={this.scrollToNext.bind(null, this.state.scrollIndex || imagesCarouselMinCount, imagesCount)}>
              </button>
      </div>
        } 
      </div>
    );
  }
});

module.exports = StaticImagePreviewSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/StaticImagePreviewSection.jsx